module.exports = __webpack_public_path__ + "img/pic2-2.e2922b48.png";